export const PVC_URL = 'pvc'
